import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import DialogContentText from '@mui/material/DialogContentText';
import { Fragment, useCallback } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { PanelItem } from '../../panels/panelItem';
import { PanelItemDivider } from '../../panels/panelItemDivider';
import { thunkShowPlayerInfo } from '../../redux/actions/playerInfoActions';
import { useAppDispatch } from '../../redux/store';
import { DEFAULT_BACKGROUND_DIVIDER_COLOR, DEFAULT_BACKGROUND_HOVER_COLOR } from '../../styles/colors';
const LIST_CSS = css `
  display: flex;
  flex-direction: column;
`;
export const PlayerListMessageBoxContents = ({ onClose, players }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const onClickPlayer = useCallback((playerIdName) => {
        onClose();
        dispatch(thunkShowPlayerInfo(playerIdName, socketSend));
    }, [onClose, dispatch, socketSend]);
    if (!players.length) {
        return _jsx(DialogContentText, { children: "None" });
    }
    return (_jsx(DialogContentText, { component: 'section', css: LIST_CSS, children: players.map((player, i) => (_jsxs(Fragment, { children: [i > 0 && _jsx(PanelItemDivider, { color: DEFAULT_BACKGROUND_DIVIDER_COLOR, thicknessPx: 2 }), _jsx(PanelItem, { onClick: () => onClickPlayer(player), hoverColor: DEFAULT_BACKGROUND_HOVER_COLOR, children: player.name })] }, i))) }));
};
